import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const clasificacionTerceroImporterSelectors = importerSelectors(
  'clasificacionTercero.importer',
);

export default clasificacionTerceroImporterSelectors;
